import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'facebook-third-party-glyph-icon'

export function FacebookSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path
        fill="current"
        fillRule="evenodd"
        d="M14.587 23v-6.998H13v-2.39h1.589c0-.206-.007-.38.003-.551.033-.732.012-1.477.119-2.197.16-1.091.818-1.688 1.835-1.808.198-.023.4-.05.597-.051.602-.008 1.205-.004 1.828-.004v2.419c-.407 0-.805-.01-1.201.002-.59.02-.76.215-.766.857-.003.424 0 .847 0 1.308H19l-.234 2.392h-1.772V23h-2.407Z"
        clipRule="evenodd"
      />
    </symbol>
  )
}

const FacebookStandaloneContent = standalone(FacebookSymbol, ID)

export const Facebook = styled(function FacebookStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-facebook">
      <FacebookStandaloneContent />
    </Icon>
  )
})``

export const FacebookLightweight = styled(function FacebookComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-facebook">
      {lightweight(ID)}
    </Icon>
  )
})``
